module.exports = __webpack_public_path__ + "img/space-introduce-1-en.828dd589.svg";